import React from 'react';
import './Banner.css';

const Banner = () => {
    return (
        <div className="awareness-banner">
            <div className="banner-content">
                <span className="banner-text">
                   The Gates of Discovery Have Opened - Welcome to MedXplore.
                </span>
            </div>
        </div>
    );
};

export default Banner;